import React, { Component } from 'react';
import $ from "jquery";

class DashboardHeading extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $('title').text(this.props.title);
}

hide_deshboard_nemu(){
    $('#dashboard_right_card').toggleClass('width100');
    $('#dashboard_left_menu_card').toggleClass('hide-im');
}

  render() {
    return (
        <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
            <div className="col-md-12 p-3 width100">
                <p className="dashboar-title">
                <i className="fa fa-bars hamburger-menu-icon text-white-50" aria-hidden="true" onClick={this.hide_deshboard_nemu.bind(this)}></i>
                <span className="text-white-50">{this.props.title}</span></p>
            </div>
        </nav>
    );
  }
}

export default DashboardHeading;
